import { message, Table, Tag, Typography } from "antd";
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { FC, useEffect, useState } from "react";
import { notification } from 'antd';
import moment from "moment-jalaali";
import Actions from "../actions";
import { useNavigate } from "react-router-dom";
import restful from "../../restful";

interface DataType {
    user: String,
    cost: number,
    unit: String,
    action: String,
    _id: String
    createdAt: Date
    updatedAt: Date
}

interface Params { page?: number; perPage?: number, sortDir: string, sort: string }

const TransactionsTable: FC<{ filters: any }> = ({ filters }) => {
    const navigate = useNavigate()
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [items, setItems] = useState<DataType[]>([]);
    const [pagination, setPagination] = useState<TablePaginationConfig>({
        current: 1,
        pageSize: 10,
    });

    const onDeleteAction = (id: string) => {
        restful.delete('/transactions/' + id)
            .then((res) => {
                fetchData({ sortDir: "desc", sort: "updatedAt", page: pagination.current, perPage: pagination.pageSize })
            })
            .catch((err) => message.error(err.message));
    }

    const columns: ColumnsType<DataType> = [
        {
            sorter: true, title: 'موبایل', dataIndex: 'user', key: 'mobile', width: 120,
            render(val) { return val?.mobile }
        },
        {
            sorter: true, title: 'کاربر', dataIndex: 'user', key: 'name',
            render(val) { return val?.name }
        },


        {
            sorter: true, title: 'مبلغ', dataIndex: 'cost', key: 'cost', width: 100,
            render(val) {
                return <Typography.Text type={val > 0 ? "success" : "danger"} >{Math.abs(val).toLocaleString()}</Typography.Text>
            }
        },
        {
            sorter: true, title: 'واحد', dataIndex: 'unit', key: 'unit', width: 80,
            render(val) {
                if (val == "toman") return <Tag color="green">تومان</Tag>;
                if (val == "coin") return <Tag color="gold">سکه</Tag>;
                return val
            },
        },
        {
            width: 120,
            sorter: true, title: 'توضیح', dataIndex: 'action', key: 'action',
            render(val) {
                if (val == "adivery") return "تبلیغ ادیوری";
                if (val == "creditPack") return "خرید پکیج";
                if (val == "order") return "ثبت سفارش";
                if (val == "voted") return "نظرسنجی";
                if (val == "cart") return "کارت به کارت";
                if (val == "refunded") return "بازگشت وجه  ";
                if (val == "init") return "انتقال داده ها";
                if (val == "register") return "ثبت نام";
                if (val == "withdrawal") return "برداشت از حساب";
                return val
            },
        },
        {
            defaultSortOrder: 'descend',
            sorter: true, title: 'زمان ایجاد', dataIndex: 'createdAt', key: 'createdAt', width: 170,
            render(val) {
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },
        {
            defaultSortOrder: 'descend',
            sorter: true, title: 'بروزرسانی', dataIndex: 'updatedAt', key: 'updatedAt', width: 170,
            render(val) {
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },

    ];

    const fetchData = (params: Params) => {
        setIsLoaded(true);
        restful.get(`/transactions/paginate`, { params: {...params, ...filters} })
            .then((res) => {
                const result = res.data.result
                setItems(result.transactions);
                setPagination({
                    current: params.page,
                    pageSize: params.perPage,
                    total: result.transactionsCount,
                })
            })
            .catch((error) => {
                return notification.error({
                    message: 'Error ' + error.statusCode,
                    description: error.message,
                });
            })
            .finally(() => { setIsLoaded(false) })
    };

    useEffect(() => {
        fetchData({ sortDir: "desc", sort: "updatedAt", page: pagination.current, perPage: pagination.pageSize });
    }, [filters])

    const handleTableChange = (newPagination: TablePaginationConfig, filter: any, sorter: any) => {
        if (pagination.pageSize !== newPagination.pageSize) newPagination.current = 1
        fetchData({
            page: newPagination.current,
            perPage: newPagination.pageSize,
            sortDir: sorter.order === "ascend" ? "asc" : "desc",
            sort: sorter.field ?? "updatedAt"
        });
    };

    return <Table
        columns={columns}
        dataSource={items}
        loading={isLoaded}
        rowKey="_id"
        pagination={pagination}
        onChange={handleTableChange}
    />
}

export default TransactionsTable


